import { FilterMapper, FilterValue, extractFilterValues } from '@nexelem/filters';
import { SimulationListFilterData } from '@nexelem/graphne-api';
import { RequestFormatters } from '@nexelem/utils';
import { endOfDay, startOfDay } from 'date-fns';

export const simulationListFilterMapper = (): FilterMapper<SimulationListFilterData> => {
  return {
    status: extractFilterValues,
    creationDate: (
      filter: FilterValue<SimulationListFilterData['creationDate']>,
    ): SimulationListFilterData['creationDate'] => {
      if (filter.value?.from && filter.value?.to) {
        return {
          from: RequestFormatters.date.withHoursForBackend(startOfDay(new Date(filter.value.from))),
          to: RequestFormatters.date.withHoursForBackend(endOfDay(new Date(filter.value.to))),
        };
      }
      return undefined;
    },
  };
};
